import { CommonModule, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ActionButton } from '@core/interfaces/action-button.model';
import { PlatformService } from '@core/services/platform.service';
import { IonicModule, ModalController } from '@ionic/angular';
import { ComponentProps, ComponentRef } from '@ionic/core';
import { TranslateModule } from '@ngx-translate/core';

export interface AlertSystemMessagesOptionsModel extends ComponentProps<ComponentRef> {
    title: string;
    iconSize?: number;
    description?: string;
    iconName?: string;
    iconColor?: string;
    svgIcon?: string;
    buttons?: ActionButton[];
}

@Component({
    selector: 'ncodp-alert-system-messages',
    templateUrl: 'alert-system-messages.component.html',
    styleUrls: ['alert-system-messages.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, NgClass, TranslateModule, IonicModule],
})
export class AlertSystemMessagesComponent {
    public isIos$ = this.platform.isIosPlatform$;
    @Input() public title = '';
    @Input() public paramsTitle = null;
    @Input() public paramsDescription = null;
    @Input() public iconSize = 70;
    @Input() public description = '';
    @Input() public iconName = 'checkmark-circle-outline';
    @Input() public iconColor = 'primary';
    @Input() public svgIcon = '';
    @Input() public buttons: ActionButton[] = [];
    @Input() public buttonsWrapperClasses: string = '';

    constructor(
        private modalCtrl: ModalController,
        private platform: PlatformService,
    ) {}

    public ionViewWillEnter(): void {}

    public ionViewWillLeave(): void {}

    public pushAction(trigger: string) {
        this.modalCtrl.dismiss(true, trigger).then();
    }
}
